import { useSubheader } from "../../../../_metronic/layout/index.js"
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../component/atoms/RowModule/RowModule.jsx"
import {
  ButtonDropdown,
  FilterCard,
  LocationMolecule,
  RadioButtonGroup,
  SelectInput,
  TabsWithIcon
} from "../../../../component/index.jsx"
import { initialFilterTable } from "../../../../component/atoms/Tabel/index.jsx"
import { getUrlParsingPageFilter } from "../../../../config/EndpointCollection.js"
import { useLocation } from "react-router"
import { useUrlParam } from "../../../hooks/useUrlParams.jsx"
import { useDispatch, useSelector } from "react-redux"
import {
  blacklistMitras,
  clearDataDetail,
  freezeMitras,
  getListMitraV3,
  getTypeMitra,
  unfreezeMitras
} from "../../../../redux/actions/MitraAction.jsx"
import { RoutesConstants } from "../../../../constants/RoutesConstants.js"
import { setDataTabMultiple, SetFilterAction } from "../../../../redux/actions/FilterAction.js"
import { useTranslation } from "react-i18next"
import { Pending } from "./tab/Pending.jsx"
import { Active } from "./tab/Active.jsx"
import {
  LABELING_CONST,
  MITRA_ACTIVE_CONTRACT_STATUS_ENUM,
  ROUTING_STATUS,
  isFrozen
} from "../../../../constants/StringConstant.js"
import { Reject } from "./tab/Reject.jsx"
import { Inactive } from "./tab/Inactive.jsx"
import {
  getListRegionalSelected,
  getListSubRegionalByRole
} from "../../../../redux/actions/MasterDataAction.jsx"
import { getKeyFromValue } from "../../../helpers/Utils.js"
import { FloatingSelectArea } from "../../../../component/atoms/FloatingSelectArea/index.jsx"
import { Button } from "react-bootstrap"
import { ModalFreezeMitra } from "./components/ModalFreezeMitra.jsx"
import { ModalBlacklistMitra } from "./components/ModalBlacklistMitra.jsx"
import { ModalUnfreezeMitra } from "./components/ModalUnfreezeMitra.jsx"
import { ICON_CONSTANTS, ILLUSTRATION_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers.js"
import { MITRA } from "../../../../constants/InitTypeConstants.js"
import swal from "sweetalert"
import { loadUserLogin } from "../../../../config/index.jsx"
import { PRIVILEGE_ENUM } from "../../../../constants/PrivilegeConstants.js"
import { ROLE_ENUM } from "../../../../constants/RoleConstants.js"

export function ListMitra({
  history,
  match: {
    params: { tab }
  }
}) {
  const subHeader = useSubheader()
  const formRef = useRef()
  const location = useLocation()
  const urlParams = useUrlParam()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { General, Mitra, MasterData } = useSelector((state) => state)

  const [search, setSearch] = useState({
    keyword: ""
  })
  const [initialValue, setInitialValue] = useState({
    ...initialFilterTable,
    regional_id: "",
    sub_regional_id: "",
    mitra_type: "",
    province_id: "",
    regency_id: "",
    district_id: "",
    sub_district_id: "",
    label_type: "",
    document_complete: ""
  })
  const [filterOn, setFilterOn] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [btnFilterDisable, setBtnFilterDisable] = useState(true)
  const [reset, setReset] = useState(false)
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [tabActive, setTabActive] = useState(0)
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const isReadOnly = false
  const [labelTypeSelect, setLabelTypeSelect] = useState()
  const [isSelectable, setIsSelectable] = useState(false)
  const [isFreeze, setIsFreeze] = useState(false)
  const [isBlacklist, setIsBlacklist] = useState(false)
  const [isUnfreeze, setIsUnfreeze] = useState(false)
  const [freezeItems, setFreezeItems] = useState([])
  const [blacklistItems, setBlacklistItems] = useState([])
  const [unfreezeItems, setUnfreezeItems] = useState([])
  const [showFreezeModal, setShowFreezeModal] = useState(false)
  const [showBlacklistModal, setShowBlacklistModal] = useState(false)
  const [showUnfreezeModal, setShowUnfreezeModal] = useState(false)
  const [selectedRegional, setSelectedRegional] = useState(null)
  const [selectedSubRegional, setSelectedSubRegional] = useState(null)
  const [selectedMitraType, setSelectedMitraType] = useState()
  const [listMitraType, setListMitraType] = useState([])
  const [listRegional, setListRegional] = useState([])
  const [listSubRegional, setListSubRegional] = useState([])
  const [selectedRegionalUser, setSelectedRegionalUser] = useState()
  const userLogin = JSON.parse(localStorage.getItem("userLogin"))
  const [enableSubRegional, setEnableSubRegional] = useState(false)
  const [activeFilterAndSearch, setActiveFilterAndSearch] = useState(false)
  const [isChangeRegional, setIsChangeRegional] = useState(false)
  const [selectedDocStatus, setSelectedDocStatus] = useState("")
  const privileges = loadUserLogin().privilege
  const role = loadUserLogin().role

  useEffect(() => {
    if (userLogin?.regional_id) {
      setSelectedRegionalUser(userLogin?.regional_id)
    }
  }, [])

  useEffect(() => {
    if (listRegional && selectedRegional) {
      const data = listRegional.find((e) => e.value === selectedRegionalUser)
      if (data) {
        setSelectedRegional(data.value)
        if (formRef.current) {
          formRef.current.setFieldValue("regional_id", data.value)
        }
      }
    }
  }, [listRegional, selectedRegionalUser])

  useEffect(() => {
    if (listSubRegional && selectedSubRegional) {
      const data = listSubRegional.find((e) => e.value === selectedSubRegional)
      if (data) {
        setSelectedSubRegional(data.value)
        if (formRef.current) {
          formRef.current.setFieldValue("sub_regional_id", data.value)
        }
      }
    }
  }, [listSubRegional, selectedSubRegional])

  useEffect(() => {
    if (filterOn || isActiveSearch) {
      setActiveFilterAndSearch(true)
    } else {
      setActiveFilterAndSearch(false)
    }
  }, [filterOn, isActiveSearch])

  useEffect(() => {
    if (Mitra?.type) {
      setListMitraType(
        Mitra.type.map((item) => {
          return {
            label: item.title,
            value: item.mitra_type_enum
          }
        })
      )
    }
  }, [Mitra])

  useEffect(() => {
    if (MasterData?.listRegionalSelected) {
      setListRegional(
        MasterData.listRegionalSelected.map((item) => {
          return {
            label: item.name + " (" + item.code + ")",
            value: item.id
          }
        })
      )
    }
    if (isChangeRegional) {
      setSelectedSubRegional("")
      setListSubRegional([])
      setIsChangeRegional(false)
    }
    if (MasterData?.listSubRegionalByRole) {
      setListSubRegional(
        MasterData.listSubRegionalByRole.map((item) => {
          return {
            label: item.name,
            value: item.id
          }
        })
      )
    }
  }, [MasterData])

  useEffect(() => {
    if (tab === ROUTING_STATUS.STATUS_ENUM.ACTIVE) {
      setTabActive(1)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.PENDING) {
      setTabActive(0)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.REJECTED) {
      setTabActive(2)
    } else if (tab === ROUTING_STATUS.STATUS_ENUM.INACTIVE) {
      setTabActive(3)
    }
  }, [tab])

  const dropdownMenu = useMemo(
    () => [
      {
        title: t("label_freeze"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.PAUSE),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isFreeze) {
            setFreezeItems([])
            setIsSelectable(false)
            setIsFreeze(false)
          } else {
            setIsBlacklist(false)
            setBlacklistItems([])
            setIsUnfreeze(false)
            setUnfreezeItems([])
            setIsFreeze(true)
            setIsSelectable(true)
          }
        }
      },
      {
        title: t("label_blacklist"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.BLACKLIST),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isBlacklist) {
            setBlacklistItems([])
            setIsSelectable(false)
            setIsBlacklist(false)
          } else {
            setIsFreeze(false)
            setFreezeItems([])
            setIsUnfreeze(false)
            setUnfreezeItems([])
            setIsBlacklist(true)
            setIsSelectable(true)
          }
        }
      },
      {
        title: t("label_unfreeze"),
        icon: toAbsoluteUrl(ICON_CONSTANTS.ACTION.UNFREEZE),
        showed: true,
        disabled: privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) < 0,
        action: () => {
          if (isUnfreeze) {
            setUnfreezeItems([])
            setIsSelectable(false)
            setIsUnfreeze(false)
          } else {
            setIsFreeze(false)
            setFreezeItems([])
            setIsBlacklist(false)
            setBlacklistItems([])
            setIsUnfreeze(true)
            setIsSelectable(true)
          }
        }
      }
    ],
    [isFreeze, isBlacklist, isUnfreeze, t]
  )

  useEffect(() => {
    subHeader.setTitle(t("sub_header_mitra_list"))
    dispatch(getTypeMitra())
    dispatch(getListRegionalSelected())
    return () => {
      dispatch(clearDataDetail())
    }
  }, [])

  useEffect(() => {
    const isSuperAdmin = role === ROLE_ENUM.SUPER_ADMIN
    if (
      tabActive === 1 &&
      privileges.indexOf(PRIVILEGE_ENUM.LABELING_MANAGEMENT) > -1 &&
      !isSuperAdmin &&
      role === ROLE_ENUM.FINANCE
    ) {
      subHeader.setButton(
        <ButtonDropdown variant={"outline-primary"} title={"Actions"} dropdownList={dropdownMenu} />
      )
    } else {
      subHeader.setButton(null)
    }
  }, [isSelectable, isFreeze, isBlacklist, isUnfreeze, tabActive, dropdownMenu])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete && General.actionInitType === MITRA.FREEZE_MITRA) {
      swal(t("messages_response_success_freeze_mitra"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_FREEZE_MITRA
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === MITRA.BLACKLIST_MITRA) {
      swal(t("messages_response_success_blacklist_mitra"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_BLACKLIST_MITRA
      }).then(() => {
        history.replace(0)
      })
    }
    if (General.isFinishUpdateOrDelete && General.actionInitType === MITRA.UNFREEZE_MITRA) {
      swal(t("messages_response_success_unfreeze_mitra"), {
        icon: ILLUSTRATION_CONSTANTS.SUCCESS_UNFREEZE_MITRA
      }).then(() => {
        history.replace(0)
      })
    }
  }, [General.isFinishUpdateOrDelete, General.actionInitType])

  useEffect(() => {
    if (selectedRegional) {
      dispatch(getListSubRegionalByRole(selectedRegional, userLogin?.role))
      setEnableSubRegional(true)
    } else {
      setListSubRegional([])
      setEnableSubRegional(false)
      setSelectedRegional("")
    }
  }, [selectedRegional])

  useEffect(() => {
    if (
      formRef.current.values.province_id ||
      labelTypeSelect ||
      formRef.current.values.mitra_type ||
      formRef.current.values.sub_regional_id ||
      selectedSubRegional ||
      selectedMitraType ||
      selectedDocStatus
    ) {
      setBtnFilterDisable(false)
    } else {
      setBtnFilterDisable(true)
    }
  }, [formRef.current, labelTypeSelect, selectedSubRegional, selectedMitraType, selectedDocStatus])

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
    if (
      queryStringObj?.province_id ||
      queryStringObj?.regency_id ||
      queryStringObj?.district_id ||
      queryStringObj?.sub_district_id ||
      queryStringObj?.mitra_type ||
      queryStringObj?.regional_id ||
      queryStringObj?.label_type ||
      queryStringObj?.sub_regional_id ||
      queryStringObj?.document_complete
    ) {
      if (userLogin?.regional_id) {
        if (
          queryStringObj?.province_id ||
          queryStringObj?.regency_id ||
          queryStringObj?.district_id ||
          queryStringObj?.sub_district_id ||
          queryStringObj?.mitra_type ||
          queryStringObj?.label_type ||
          queryStringObj?.sub_regional_id ||
          queryStringObj?.document_complete
        ) {
          setFilterOn(true)
        } else {
          setFilterOn(false)
        }
      } else {
        setFilterOn(true)
      }
      const data = {
        ...initialFilterTable,
        keyword: queryStringObj?.keyword,
        province_id: queryStringObj?.province_id,
        regency_id: queryStringObj?.regency_id,
        district_id: queryStringObj?.district_id,
        sub_district_id: queryStringObj?.sub_district_id,
        label_type: queryStringObj?.label_type,
        mitra_type: queryStringObj?.mitra_type,
        regional_id: queryStringObj?.regional_id,
        sub_regional_id: queryStringObj?.sub_regional_id,
        document_complete: queryStringObj?.document_complete
      }
      if (data) {
        setInitialValue(data)
        setSelectedMitraType(data.mitra_type)
        setSelectedRegional(data?.regional_id)
        setSelectedSubRegional(data?.sub_regional_id)
        setLabelTypeSelect(data?.label_type)
        setSelectedDocStatus(data?.document_complete)
      }
    }
  }, [queryStringObj, dispatch])

  useEffect(() => {
    const result = location?.search
    fetchData(result)
  }, [location.search])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  function onChangeRegional(e) {
    if (e) {
      dispatch(getListSubRegionalByRole(e, userLogin?.role))
      setSelectedRegional(e)
    } else {
      setSelectedRegional(null)
    }
    setIsChangeRegional(true)
    setSelectedSubRegional("")
  }

  const fetchData = (param) => {
    if (userLogin?.regional_id) {
      if (param === "" || param === null) param = param + "?regional_id=" + userLogin?.regional_id
    }
    return dispatch(getListMitraV3(tab, param))
  }

  // search
  const searchFunc = (values) => {
    setSearch({ keyword: values.keyword })
    setIsActiveSearch(true)
    let param = {
      ...initialFilterTable,
      ...initialValue,
      keyword: values.keyword
    }
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleReset = () => {
    let param = {
      ...initialFilterTable,
      ...initialValue,
      keyword: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ keyword: "" })
    setSelectedMitraType("")
    setIsActiveSearch(false)
    setSelectedSubRegional("")
    setSelectedRegional("")
    history.push({ pathname: location.pathname, search: urlParam })
  }

  // filter
  const filterComponent = (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_regional")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="regional_id"
              editable={!selectedRegionalUser}
              options={listRegional}
              onChange={onChangeRegional}
              value={selectedRegional}
              label={t("label_regional_name")}
              placeholder={t("placeholder_insert_regional_name")}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name={"sub_regional_id"}
              editable={enableSubRegional}
              options={listSubRegional}
              onChange={(e) => setSelectedSubRegional(e)}
              value={selectedSubRegional}
              label={t("label_sub_regional")}
              placeholder={t("placeholder_insert_sub_regional_name")}
            />
          </RowModule>
        </CardBody>
      </Card>

      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_mitra")} className="px-0" />
        <CardBody className="px-0">
          <RowModule>
            <SelectInput
              name="mitra_type"
              editable={!isReadOnly}
              label={t("label_mitra_type")}
              placeholder={t("placeholder_select_one")}
              options={listMitraType}
              withoutFeedback={true}
              clearNow={true}
              value={selectedMitraType}
              onChange={(e) => setSelectedMitraType(e)}
            />
          </RowModule>
        </CardBody>
      </Card>
      <LocationMolecule
        regionalId={checkRegionalSelected()}
        resetLocation={reset}
        name="filter"
        withoutFeedback={true}
        isReadOnly={isReadOnly}
        addressTitle={t("label_location")}
        removeHorizontalPadding={true}
      />
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_kemitraan_status")} className="px-0" />
        <CardBody className="px-0">
          <RadioButtonGroup
            editable={true}
            label={t("label_freeze")}
            value={LABELING_CONST.FROZEN}
            onClick={() => setLabelTypeSelect(LABELING_CONST.FROZEN)}
            checked={labelTypeSelect === LABELING_CONST.FROZEN}
            name="label_type"
          />
          <RadioButtonGroup
            editable={true}
            label={t("label_blacklist")}
            value={LABELING_CONST.BLACKLISTED}
            onClick={() => setLabelTypeSelect(LABELING_CONST.BLACKLISTED)}
            checked={labelTypeSelect === LABELING_CONST.BLACKLISTED}
            name="label_type"
          />
        </CardBody>
      </Card>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_document_status")} className="px-0" />
        <CardBody className="px-0">
          <RadioButtonGroup
            editable={true}
            label={t("label_complete")}
            value={"true"}
            onClick={() => setSelectedDocStatus("true")}
            checked={selectedDocStatus === "true"}
            name="document_complete"
          />
          <RadioButtonGroup
            editable={true}
            label={t("label_incomplete")}
            value={"false"}
            onClick={() => setSelectedDocStatus("false")}
            checked={selectedDocStatus === "false"}
            name="document_complete"
          />
        </CardBody>
      </Card>
    </>
  )

  function checkRegionalSelected() {
    if (userLogin?.regional_id) {
      return userLogin?.regional_id
    } else {
      if (selectedRegional) {
        return selectedRegional
      }
    }
  }
  const onSubmitForm = (e) => {
    setReset(false)
    const { values, submited } = e
    if (submited === true) {
      const base = queryStringObj || {}
      let param = {
        ...initialFilterTable,
        province_id: values.province_id,
        regency_id: values.regency_id,
        district_id: values.district_id,
        sub_district_id: values.sub_district_id,
        keyword: search.keyword,
        label_type: labelTypeSelect,
        mitra_type: values.mitra_type,
        regional_id: selectedRegionalUser ? selectedRegionalUser : checkRegionalSelected(),
        sub_regional_id: values.sub_regional_id ? values.sub_regional_id : selectedSubRegional,
        contract_status: base?.contract_status,
        document_complete: selectedDocStatus
      }
      if (param) {
        setInitialValue(param)
        const urlParam = getUrlParsingPageFilter(param)
        setSelectedRegionalUser(userLogin?.regional_id)
        history.push({ pathname: location.pathname, search: urlParam })
        setShowFilter(false)
        setFilterOn(true)
      }
    }
  }
  useEffect(() => {
    if (selectedRegionalUser) {
      const currentParams = urlParams?.getUrlParamsObj || {}
      const param = {
        ...initialFilterTable,
        ...initialValue,
        regional_id: selectedRegionalUser,
        ...currentParams
      }
      if (param) {
        setInitialValue(param)
        const urlParam = getUrlParsingPageFilter(param)
        history.push({ pathname: location.pathname, search: urlParam })
      }
    }
  }, [selectedRegionalUser, tab])
  const filterOnReset = () => {
    dispatch(SetFilterAction())
    setReset(true)
    setShowFilter(false)
    setFilterOn(false)
    let param = {
      ...initialFilterTable,
      province_id: "",
      regency_id: "",
      district_id: "",
      sub_district_id: "",
      keyword: search.keyword,
      label_type: "",
      mitra_type: "",
      regional_id: selectedRegionalUser ? selectedRegionalUser : "",
      sub_regional_id: "",
      document_complete: "",
      ...(queryStringObj?.contract_status && { contract_status: queryStringObj?.contract_status })
    }
    setSelectedSubRegional("")
    setSelectedRegional(null)
    setSelectedRegionalUser(userLogin?.regional_id || "")
    setInitialValue(param)
    setSelectedMitraType("")
    setLabelTypeSelect("")
    setSelectedDocStatus("")
    const urlParam = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const handleOpenCloseFilter = (value) => {
    setShowFilter(value)
  }

  const changePage = useCallback(
    (param) => {
      const currentParams = new URLSearchParams(location.search)
      const currentTab = currentParams.get("contract_status")

      const base = {
        ...initialValue,
        ...param,
        keyword: search.keyword,
        ...(currentTab && { contract_status: currentTab })
      }

      const finalParam = {
        ...base,
        sort: param.sortField ? `${param.sortField},${param.sortOrder}` : ""
      }

      const urlParam = getUrlParsingPageFilter(finalParam)
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [location.search, search, initialValue]
  )

  const changeTabs = (data) => {
    dispatch(setDataTabMultiple(data))
    setTabActive(data)
    let urlParam = ""
    let param = {
      ...initialValue,
      keyword: search.keyword
    }
    urlParam = getUrlParsingPageFilter(param)
    if (data === 0) {
      history.push(
        RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.PENDING) + urlParam ?? ""
      )
    } else if (data === 1) {
      history.push(
        RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.ACTIVE) +
          getUrlParsingPageFilter({
            ...param,
            contract_status: getKeyFromValue(
              MITRA_ACTIVE_CONTRACT_STATUS_ENUM.ALL_CONTRACTS,
              MITRA_ACTIVE_CONTRACT_STATUS_ENUM
            )
          }) ?? ""
      )
    } else if (data === 2) {
      history.push(
        RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.REJECTED) + urlParam ?? ""
      )
    } else if (data === 3) {
      history.push(
        RoutesConstants.MITRA.LIST_MITRA(ROUTING_STATUS.STATUS_ENUM.INACTIVE) + urlParam ?? ""
      )
    }
  }

  const handleSelectionChange = useCallback(
    (rows) => {
      if (isFreeze) {
        setFreezeItems(rows)
      } else if (isBlacklist) {
        setBlacklistItems(rows)
      } else if (isUnfreeze) {
        setUnfreezeItems(rows)
      }
    },
    [isFreeze, isBlacklist, isUnfreeze]
  )

  const handleChangeSubTab = (tab) => {
    let param = getUrlParsingPageFilter({
      ...queryStringObj,
      contract_status: tab,
      sort: ""
    })

    history.push({ pathname: location.pathname, search: param })
  }

  const getTabsContents = () => {
    const labelList = [
      {
        label: t("label_pending"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_active"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_reject"),
        labelTooltip: "",
        icon: ""
      },
      {
        label: t("label_inactive"),
        labelTooltip: "",
        icon: ""
      }
    ]
    const ComponentsList = [
      <Pending
        key={0}
        data={Mitra}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />,
      <Active
        key={1}
        data={Mitra}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
        handleChangeSubTab={handleChangeSubTab}
        initialActive={queryStringObj?.contract_status}
        isMultiSelect={isSelectable}
        actionType={
          isFreeze
            ? LABELING_CONST.FREEZE
            : isBlacklist
            ? LABELING_CONST.BLACKLIST
            : isUnfreeze
            ? LABELING_CONST.UNFREEZE
            : null
        }
        onSelectionChange={handleSelectionChange}
      />,
      <Reject
        key={2}
        data={Mitra}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />,
      <Inactive
        key={3}
        data={Mitra}
        changePage={changePage}
        history={history}
        general={General}
        initialFilterTable={initialFilterTable}
        isFilter={activeFilterAndSearch}
        status={tab}
      />
    ]

    return {
      labels: labelList,
      contents: ComponentsList
    }
  }

  return (
    <>
      <FilterCard
        // seacrh
        isActiveSearch={isActiveSearch}
        placeholder={t("placeholder_search_mitra_name_or_id")}
        onSubmitForm={searchFunc}
        initialValues={search}
        name={"keyword"}
        innerRef={formRef}
        trigerReset={handleReset}
        // filter
        filterInnerRef={formRef}
        filterHandleSubmit={onSubmitForm}
        filterFormInitialValues={initialValue}
        filterComponent={filterComponent}
        filterOnReset={filterOnReset}
        showFilter={showFilter}
        handleOpenCloseFilter={handleOpenCloseFilter}
        filterOn={filterOn}
        btnDisable={btnFilterDisable}></FilterCard>
      <TabsWithIcon
        labelTab={getTabsContents().labels}
        componentTab={getTabsContents().contents}
        changeTab={changeTabs}
        initValue={tabActive}
      />
      {isSelectable && isFreeze ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_mitra")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.MITRA_GREEN)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsFreeze(false)
                  setIsSelectable(false)
                  setFreezeItems([])
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={freezeItems.length === 0}
                onClick={() => setShowFreezeModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_freeze")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {freezeItems.length} {t("label_mitra")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      {isSelectable && isBlacklist ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_mitra")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.MITRA_GREEN)}
          customButtonSection={() => (
            <>
              <Button
                variant="outline-primary"
                onClick={() => {
                  setIsBlacklist(false)
                  setIsSelectable(false)
                  setBlacklistItems([])
                }}
                className={"d-flex align-items-center ml-4"}>
                {t("button_batal")}
              </Button>
              <Button
                variant="primary"
                disabled={blacklistItems.length === 0}
                onClick={() => setShowBlacklistModal(true)}
                className={"d-flex align-items-center ml-4"}>
                {t("label_blacklist")}
              </Button>
            </>
          )}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {blacklistItems.length} {t("label_mitra")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      {isSelectable && isUnfreeze ? (
        <FloatingSelectArea
          disableButton={false}
          label={t("label_mitra")}
          buttonlabel={"button_next"}
          buttonColor={"primary"}
          labelIcon={toAbsoluteUrl(ICON_CONSTANTS.MITRA_GREEN)}
          customButtonSection={() => {
            const frozenItems = unfreezeItems.filter(
              (item) => isFrozen(item.mitra_status)
            )
            const nonFrozenItems = unfreezeItems.filter(
              (item) => !isFrozen(item.mitra_status)
            )
            return (
              <>
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    setIsUnfreeze(false)
                    setIsSelectable(false)
                    setUnfreezeItems([])
                  }}
                  className={"d-flex align-items-center ml-4"}>
                  {t("button_batal")}
                </Button>
                <Button
                  variant="primary"
                  disabled={nonFrozenItems.length > 0 || frozenItems.length === 0}
                  onClick={() => setShowUnfreezeModal(true)}
                  className={"d-flex align-items-center ml-4"}>
                  {t("label_unfreeze")}
                </Button>
              </>
            )
          }}
          totalComponent={
            <div className="color-white txt-14 pl-4">
              {unfreezeItems.length} {t("label_mitra")}
            </div>
          }
        />
      ) : (
        <></>
      )}
      <ModalFreezeMitra
        show={showFreezeModal}
        onClose={() => setShowFreezeModal(false)}
        onSubmit={(values) => {
          dispatch(
            freezeMitras({
              document: {
                name: values.file_name,
                size: values.file_size,
                url: values.file_contract_url
              },
              reason: values.reason,
              mitra_ids: freezeItems.map((item) => item.id)
            })
          )
          setShowFreezeModal(false)
          setIsFreeze(false)
          setIsSelectable(false)
        }}
      />
      <ModalBlacklistMitra
        show={showBlacklistModal}
        onClose={() => setShowBlacklistModal(false)}
        onSubmit={(values) => {
          dispatch(
            blacklistMitras({
              document: {
                name: values.file_name,
                size: values.file_size,
                url: values.file_contract_url
              },
              reason: values.reason,
              mitra_ids: blacklistItems.map((item) => item.id)
            })
          )
          setShowBlacklistModal(false)
          setIsBlacklist(false)
          setIsSelectable(false)
        }}
      />
      <ModalUnfreezeMitra
        show={showUnfreezeModal}
        onClose={() => setShowUnfreezeModal(false)}
        onSubmit={(values) => {
          const frozenItems = unfreezeItems.filter(
            (item) => isFrozen(item.mitra_status)
          )
          dispatch(
            unfreezeMitras({
              reason: values.reason,
              mitra_ids: frozenItems.map((item) => item.id)
            })
          )
          setShowUnfreezeModal(false)
          setIsUnfreeze(false)
          setIsSelectable(false)
        }}
      />
    </>
  )
}
